// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-ea392070],.fade-leave-active[data-v-ea392070]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-ea392070],.fade-leave-to[data-v-ea392070]{opacity:0}", ""]);
// Exports
module.exports = exports;
